import type { FC } from 'react';

import type { TIconProps } from './icon.props';

const IconTarget: FC<TIconProps> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.13333"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M8 13.6667C11.1296 13.6667 13.6667 11.1296 13.6667 8C13.6667 4.87039 11.1296 2.33333 8 2.33333C4.87039 2.33333 2.33333 4.87039 2.33333 8C2.33333 11.1296 4.87039 13.6667 8 13.6667Z"
    />
    <path
      d="M8 10.3333C9.28866 10.3333 10.3333 9.28866 10.3333 8C10.3333 6.71134 9.28866 5.66667 8 5.66667C6.71134 5.66667 5.66667 6.71134 5.66667 8C5.66667 9.28866 6.71134 10.3333 8 10.3333Z"
    />
  </svg>
);

export {
  IconTarget,
};
